import React, { Fragment } from 'react';

// === Components === //
import Container from '@components/common/Container';
import EventsListItem from '@components/sections/components/EventsListItem';

// === Styles === //
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { colors, dimensions, breakpoints, respondTo } from '@styles';

// === Types === //
import { Variant } from '@content/types/layout';
import { EventData } from '@content/types/page';

const EventsListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Category = styled.h2`
  font-size: ${dimensions.fontSize.lg_md}px;
  color: ${colors.text.light};
  margin-bottom: 30px;
`;

const EventsListBox = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 15px;
  ${respondTo(
    breakpoints.md,
    css`
      justify-content: center;
    `
  )}
`;

interface EventsProps {
  list: EventData[];
  variant: Variant;
  type: '1' | '2';
}

const Events = ({ list, variant, type }: EventsProps) => {
  const today = new Date();

  const compareDates = (endDate) => {
    const todayGetTime = today.getTime();
    const endDateFormat = new Date(endDate);
    const endDateGetTime = endDateFormat.getTime();
    let compare = true;

    if (type === '2') {
      if (!endDate || todayGetTime < endDateGetTime) {
        compare = false;
      } else {
        compare = true;
      }
    } else {
      if (endDate && todayGetTime > endDateGetTime) {
        compare = false;
      } else {
        compare = true;
      }
    }
    return compare;
  };

  const eventsList = list.filter((event) => compareDates(event.date.start) === true);
  const categories = eventsList.map((event) => event.category);
  const uniqueCategories = [...new Set(categories)];

  return (
    <Container>
      <EventsListWrapper>
        {uniqueCategories.map((category) => (
          <Fragment key={category}>
            <Category>{category}</Category>
            <EventsListBox>
              {eventsList
                .filter((event) => event.category === category)
                .map((event) => (
                  <EventsListItem
                    disabled={type === '2' ? true : false}
                    variant={variant}
                    key={event.uuid}
                    {...event}
                  />
                ))}
            </EventsListBox>
          </Fragment>
        ))}
      </EventsListWrapper>
    </Container>
  );
};

export default Events;
